import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { hasError: false, message: "" }; }
  static getDerivedStateFromError(error) { return { hasError: true, message: error?.message || "Unexpected UI error" }; }
  componentDidCatch(error, info) { console.error("ERP UI error", error, info); }
  render() {
    if (this.state.hasError) {
      return <div className="alert alert-danger m-3" style={{fontSize:12}}>
        <strong>Something went wrong on this page.</strong><br />{this.state.message}<br />Please refresh, or contact support if it repeats.
      </div>;
    }
    return this.props.children;
  }
}
